import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericAkitaHTTPService, HttpOptions } from '../../service/generic-akita-http.service';
import { NetworkService } from '../../service/network.service';
import { SMAlertRule } from '../../model/sm-alertrule';

@Injectable({
  providedIn: 'root'
})
export class AkitaSMAlertRuleHttpService extends GenericAkitaHTTPService<SMAlertRule> {
  constructor(http: HttpClient, networkService: NetworkService) {

    const options: HttpOptions = {
      params: {
        type: 'SmAlertRule',
        options: 'keyValues',
        limit: '100',
        orderBy: '!dateCreated'
      }
    };
    super(http, networkService, '/v2/entities/', 'smalertrule', options);
  }
}
